import React from "react";
import { AgentContextType } from "core/interfaces/agent-context-type.interface";

export const AgentContext = React.createContext<AgentContextType | undefined>(
  undefined
);
